import type { ReactNode } from 'react';

/**
 * The line icons the two hub pages label their groups with. They are drawn at
 * 22px in `currentColor` so the card owns the colour and the theme owns the
 * card, which is why these are not imported from an icon package with its own
 * palette.
 */
function icon(children: ReactNode): ReactNode {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden focusable="false">
      {children}
    </svg>
  );
}

export const PersonIcon = icon(<><circle cx="12" cy="8" r="3.6" /><path d="M4.5 20a7.5 7.5 0 0 1 15 0" /></>);

export const SlidersIcon = icon(<><path d="M4 7h10M18 7h2M4 17h4M12 17h8" /><circle cx="16" cy="7" r="2" /><circle cx="10" cy="17" r="2" /></>);

export const KeyIcon = icon(<><circle cx="8" cy="12" r="3.5" /><path d="M11.5 12H20M17 12v3M20 12v2.5" /></>);

export const PulseIcon = icon(<><rect x="2.5" y="4.5" width="19" height="13" rx="2" /><path d="M6 11h2.5l1.6-3 2.2 6 1.7-3H18" /><path d="M9 21h6" /></>);

export const ChartIcon = icon(<><path d="M4 4v15a1 1 0 0 0 1 1h15" /><path d="M8 15l3.5-4 3 2.5L20 7" /></>);

export const ArchiveIcon = icon(<><rect x="3.5" y="4.5" width="17" height="4" rx="1" /><path d="M5 8.5V19a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8.5" /><path d="M10 12.5h4" /></>);
